module.exports = __webpack_public_path__ + "static/media/nh.5226c242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/nh.jpg
// module id = 961
// module chunks = 0